import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { LegalNotice } from 'cpfr-common';
import { fetchLegalNotice } from './LegalNoticeSlice';
import { LegalNoticeContentSelector } from './LegalNoticeContentSelector';

export function useLegalNotice(): AbstractContentState<LegalNotice> {
    return useCmsContent(fetchLegalNotice, LegalNoticeContentSelector);
}
